import { Query as TableQuery } from "../../components/common/table/types";
import filter from "lodash/filter";
import map from "lodash/map";

export function tableConstructQueryParams(query: TableQuery) {
  return {
    offset: query.page * query.rowsPerPage,
    limit: query.rowsPerPage,
    search: query.search,
    order: filter(
      map(query.order, (order: string | null, field: string) => ({
        field,
        order
      })),
      ({ order }: { order: string | null }) => order
    ),
    filters: query.filters
  };
}
